import { usePhotoFilenameExampleQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { Spin } from 'antd'
import { useRefetchWithParent } from '../../../../../hooks/useRefetchWithParent'
import { useGlobalState } from 'context/GlobalStateContext'
import { PhotoFilename } from '../../../PhotoFilenameContext/types'
import { usePhotoFilenamesContext } from '../../../PhotoFilenameContext'

const Example: React.FC<PhotoFilename> = ({ id: classTypeId }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { loading: parentLoading } = usePhotoFilenamesContext()
  const { data, loading, refetch } = usePhotoFilenameExampleQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { input: { classTypeId, projectId: projectId! } },
  })
  useRefetchWithParent({ refetch, parentLoading })
  return (
    <Spin spinning={loading ?? false} size="small">
      {data?.photoFilenameExample}
    </Spin>
  )
}

export default Example
